/* global cURL */
export class PlanSwitcher {
  #planSection;
  #planLinks;
  #planSelect;
  #planContent;
  #lastRequestedPlanID = null;

  constructor(element) {
    this.#planSection = element;
    if (!this.#planSection.classList.contains('section--plan'))
      this.#planSection = this.#planSection.closest('.section--plan');

    if (!this.#planSection || !this.#planSection.classList.contains('section--plan')) return;

    this.#planContent = this.#planSection.querySelector('.plan-content');
    if (!this.#planContent) return;

    this.#planLinks = this.#planSection.querySelectorAll('.plan-link');
    this.#planSelect = this.#planSection.querySelector('.plan-select');
    if (this.#planLinks.length === 0 && !this.#planSelect) return;

    const initialActiveLink = this.#planSection.querySelector('.plan-link--active');
    if (initialActiveLink)
      this.#lastRequestedPlanID = initialActiveLink.dataset.planId;
    else if (this.#planSelect)
      this.#lastRequestedPlanID = this.#planSelect.value;

    this.#bindEvents();
  }

  /**
   * Sets the active link as well as the select value.
   * Depending on which of the two was changed, only one of them will otherwise be set.
   */
  #setActivePlan(planID) {
    this.#planLinks.forEach(planLink => {
      if (planLink.dataset.planId === planID) planLink.classList.add('plan-link--active');
      else planLink.classList.remove('plan-link--active');
    });
    if (this.#planSelect) this.#planSelect.value = planID;
  }

  #getPlanContent = async (planID) => {
    if (!this.#planContent) return;

    this.#lastRequestedPlanID = planID;

    // Show loading icon for slow connections.
    const planTimer = setTimeout(() => { this.#planContent.innerHTML = '<div class="loader"></div>'; }, 250);

    try {
      const response = await fetch(`${cURL}mwork/ajax/get-plan-content.jsp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `planID=${encodeURIComponent(planID)}`
      });

      // Skipping content update for stale request.
      if (this.#lastRequestedPlanID !== planID) {
        clearTimeout(planTimer);
        return;
      }

      if (!response.ok) {
        const errorText = await response.text();
        clearTimeout(planTimer);
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
      const htmlContent = await response.text();
      clearTimeout(planTimer);
      this.#planContent.innerHTML = htmlContent;
    }
    catch (error) {
      console.error('Failed to load plan content:', error);
      clearTimeout(planTimer);
      this.#planContent.innerHTML = '<p class="error">Fout bij het ophalen van de inhoud.</p>';
    }
  };

  #handleEvent(e) {
    const isEnterKeyDown = e.type === 'keydown' && e.key === 'Enter';
    if (e.type === 'click' || e.type === 'change' || isEnterKeyDown) {
      if (isEnterKeyDown) e.preventDefault();
      const plan = e.target;
      const planID = plan.value || plan.dataset.planId;
      if (planID && planID !== this.#lastRequestedPlanID) {
        this.#setActivePlan(planID);
        this.#getPlanContent(planID);
      }
    }
  }

  #bindEvents() {
    this.#planLinks.forEach(planLink => {
      planLink.addEventListener('click', e => { this.#handleEvent(e); });
      planLink.addEventListener('keydown', e => { this.#handleEvent(e); });
    });

    if (this.#planSelect)
      this.#planSelect.addEventListener('change', e => { this.#handleEvent(e); });
  }
}
